import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/operations')({
  staticData: {
    permissionSection: 'catalog',
    breadcrumb: 'Operations',
  },
  component: () => <Outlet />,
});
